const init = () => {
    changeImageHeight();
    $(window).on('resize', function () {
        setTimeout(() => {
            changeImageHeight();
        }, 200)
    })
}
const changeImageHeight = () => {
    if ($(".service-conditions")) {
        $content = $(".service-conditions .conditons-content");
        $image = $(".service-conditions .conditions-image img");
        // console.log($content.height() + 50, $image.height())

        if ($content.height() + 50 < $image.height()) {
            $image.removeClass("w-100").css({
                cssText: `height: ${($content.height() + 50)}px !important;
                width: auto !important;
                max-width: unset !important;
                `
            })
        }
        else {
            $image.addClass("w-100").css({
                cssText: `height: unset !important;
                `
            })
        }
    }
}

module.exports = init
